module.exports = __webpack_public_path__ + "img/pair-programming-test-01.704df466.png";